module.exports = "/_next/static/images/6ad19b2b4b6bc99ce41367143a0b432b-holding-device-smile@0.75x.jpg";